<!--
Componente per l'import dei dati per il flusso SIAD da file custom

Parametri che si ricevono dalla vista dove viene richiamato il componente
    PARAMETRO                     TIPOLOGIA         REQUIRED      DEFAULT             DESCRIZIONE
    business_unit_id              Number            TRUE          no default          ID della BusinessUnit di riferimento
-->

<template>
  <div class="container">
    <spinner :visible="is_loading" :overlay="true"></spinner>
    <div name="upload_form" class="well row-fluid">
      <div class="control-group field">
        <label class="control-label span3">{{ i18nJSIndex.import_format }}</label>
        <div class="controls">
          <select v-model="import_type" :disabled="import_types.length == 1">
            <option v-for="type in import_types" v-bind:key="type.id" v-bind:value="type">{{ `${type.name} (${type.format})` }}</option>
          </select>
        </div>
      </div>
      <div v-if="import_type && import_type.format == 'csv'">
        <div class="control-group field">
          <label class="control-label span3">{{ i18nJSIndex.column_separator }}</label>
          <div class="controls">
            <input type="text" class="input-mini" v-model="column_separator" />
          </div>
        </div>
        <div class="control-group field">
          <label class="control-label span3">{{ i18nJSIndex.column_headers_presents }}</label>
          <div class="controls">
            <select v-model="column_headers" :disabled="column_headers_disabled">
              <option
                v-for="column_headers_option in column_headers_options"
                v-bind:key="column_headers_option.id"
                v-bind:value="column_headers_option"
              >
                {{ column_headers_option.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="import_type">
        <label class="control-label span3">{{ i18nJSIndex.import_method }}</label>
        <div class="controls">
          <select v-model="import_method">
            <option v-for="method in import_methods" v-bind:key="method.id" v-bind:value="method">{{ method.name }}</option>
          </select>
        </div>
      </div>
      <div>
        File: <input type="file" ref="file" name="file" v-on:change="handleFileUpload()" :disabled="!this.import_type" /><br /><br />
        <span v-if="file"
          >{{ i18nJSIndex.selected_file.replace('___FILE_NAME___', file.name).replace('___ROW_COUNT___', row_count) }}<br /><br
        /></span>
        <span v-if="errors.uploadFile" class="alert">Estensione del file non supportata!</span>
        <span v-if="errors.parsing" class="alert">Errore nella decodifica del documento!</span>
      </div>
      <div>
        <button
          id="import_file"
          @click="importFile()"
          class="btn btn-primary"
          :disabled="!(import_type && import_method && column_separator && column_headers && file)"
        >
          {{ i18nJSIndex.import }}
        </button>
      </div>
      <div v-if="file_imported" class="alert alert-success">
        {{ i18nJSIndex.import_ok }}
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import spinner from '../spinner';
import { Route } from '../../route';

export default {
  name: 'siadImportsIndex',
  components: {
    spinner,
  },
  props: {
    business_unit_id: { type: Number, required: true },
  },
  data: function () {
    return {
      import_type: null,
      import_types: [
        {
          id: 1,
          cod: 'adinexus',
          name: 'AdiNexus',
          filename: 'adinexus',
          format: 'csv',
          content_type: 'application/csv',
          selected: true,
          column_separator: ';',
          column_headers: 1,
        },
      ],
      import_method: null,
      import_methods: [
        { id: 1, name: window.i18nJS.siad_imports.index.import_methods.override, method: 'override' },
        { id: 2, name: window.i18nJS.siad_imports.index.import_methods.only_missing, method: 'only_missing' },
      ],
      column_separator: null,
      column_headers_options: [
        { id: 1, name: 'Si', value: true },
        { id: 2, name: 'No', value: false },
      ],
      column_headers: null,
      column_headers_disabled: false,
      file: null,
      row_count: 0,
      filename: null,
      file_imported: false,
      is_loading: false,
      errors: {
        uploadFile: false,
        parsing: false,
      },
    };
  },
  mounted() {
    for (let i = 0; i < this.import_types.length; i++) {
      if (this.import_types[i].selected == true) {
        this.import_type = this.import_types[i];
        break;
      }
    }
  },
  watch: {
    import_type: function () {
      this.column_separator = this.import_type.column_separator;

      if (this.import_type.column_headers) {
        for (let j = 0; j < this.column_headers_options.length; j++) {
          if (this.column_headers_options[j].id == this.import_type.column_headers) {
            this.column_headers = this.column_headers_options[j];
            this.column_headers_disabled = true;
            break;
          }
        }
      } else {
        this.column_headers_disabled = false;
      }
    },
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    i18nJSIndex() {
      return this.i18nJS.siad_imports.index;
    },
    importFileUrl() {
      return `${Route.SIAD_IMPORTS}/import`;
    },
    getS3DircectPostUrl() {
      return `${Route.SIAD_IMPORTS}/get_s3_direct_post`;
    },
    getImportFileUrl() {
      return `${Route.SIAD_IMPORTS}/import`;
    },
    readyToUpload() {
      return !!(this.import_method && this.import_type && this.file);
    },
  },
  methods: {
    handleFileUpload() {
      const tmpRefFile = this.$refs.file.files[0];

      if (tmpRefFile && tmpRefFile.name.endsWith(`.${this.import_type.format}`)) {
        this.errors.uploadFile = false;
        this.errors.parsing = false;
        this.file = tmpRefFile;

        this.readFile(tmpRefFile)
          .then((result) => {
            this.row_count = this.column_headers.value ? result.length - 1 : result.length;
            this.is_loading = false;
          })
          .catch((error) => {
            console.error('Some problem during upload of file', error);
            this.errors.parsing = true;
            this.is_loading = false;
          });
      } else if (tmpRefFile && !tmpRefFile.name.endsWith(`.${this.import_type.format}`)) {
        console.error('File format not supported');
        this.errors.uploadFile = true;
      } else {
        console.error('Some problem during upload of file');
        this.errors.uploadFile = true;
      }
    },
    readFile(file) {
      this.is_loading = true;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (event) {
          const contents = event.target.result;
          const lines = contents.split('\n');
          resolve(lines);
        };
        reader.onerror = function (event) {
          reject(event);
        };
        reader.readAsText(file);
      });
    },
    importFile() {
      this.is_loading = true;

      const FD = new FormData();

      FD.append('import_type', this.import_type.cod);
      FD.append('format', this.import_type.format);
      FD.append('import_method', this.import_method.method);
      FD.append('file', this.file);

      if (this.import_type.format == 'csv') {
        FD.append('column_separator', this.column_separator);
        FD.append('column_headers', this.column_headers.value);
      }

      axios({
        method: 'post',
        url: this.getImportFileUrl,
        data: FD,
        headers: {
          'Content-type': 'multipart/form-data',
          'X-CSRF-Token': $.rails.csrfToken(),
        },
      })
        .then((res) => {
          this.file_imported = true;
          this.is_loading = false;
        })
        .catch((err) => {
          var msg = `${i18nJS.errors.critical_error}: ${err.message} - ${err.response.data}`;
          if (err.response.status === 401) {
            msg = i18nJS.access_denied;
          }
          Utils.appendToFlash('error', msg);
          this.is_loading = false;
        });
    },
  },
};
</script>

<style scoped>
.alert {
  margin-top: 20px;
}
</style>
